import { DEFAULT_CONFIG } from '@src/utils/x-ani';

export const X_ANI_CONFIG = {
  indicator: {
    ...DEFAULT_CONFIG,
    y: -100,
    opacity: 0
  }
};
